import { Client } from './client';
import { RegistrationStatus } from './registration';

export class ContractorSearchOptions {
  businessName?: string;
  contractorTypeList?: string[];
  statusList?: RegistrationStatus[];
  clientId: string;
}

export class ContractorTypeSearchOptions {
  searchText?: string;
  client?: Client;
}
